<template>
    <g>
        <path style="fill:#37333D;" d="M48,57.6l-1.3,0.1c0.8,0.8,2.5,3.1,2.5,3.1s4.2,0.8,6.8,0.9c2.6,0.1,5-4.1,5-4.1C57.5,58.6,48,57.6,48,57.6z"
        />
        <g>
            <path style="fill:#FFFFFF;" d="M58.6,60.5C58.6,60.5,58.6,60.5,58.6,60.5L53.9,62l-5.1-1.5c0,0,0,0,0,0h0c0,0,0,0,0,0c0.1-0.1,0.2-0.8,0.6-1
			c0.9-0.4,2.5-0.1,4.3-0.1c1.8,0,3.5-0.4,4.4,0.1C58.4,59.6,58.6,60.3,58.6,60.5C58.6,60.5,58.6,60.5,58.6,60.5L58.6,60.5z"/>
            <path style="fill:#FFFFFF;" d="M59.5,57.7L59.5,57.7C59.5,57.7,59.5,57.7,59.5,57.7l-5.8,0l-5.8,0c0,0,0,0,0,0h0c0,0,0,0,0,0
			c0,0,0,0.1,0,0.1l-0.1,0c0,0,0,0,0,0h0c0,0,0,0,0,0c0.1,0.2,0.2,0.9,0.7,1.1c1.1,0.7,2.9,1.1,5.1,1c2.2,0.1,4.1-0.3,5.2-1
			c0.4-0.3,0.5-0.9,0.6-1.1c0,0,0,0,0,0h0c0,0,0,0,0,0l0,0C59.5,57.8,59.5,57.8,59.5,57.7C59.5,57.7,59.5,57.7,59.5,57.7z"/>
        </g>
        <g>
            <path style="fill:#ED625F;" d="M61,57.6c-1.7,1.7-3.3,3.1-5,3.3c-0.4,0.1-1.2,0.2-2.2,0.2c-1,0-1.8-0.2-2.2-0.2c-1.6-0.2-3.3-1.6-5-3.3
			c0,0-0.1,0-0.1,0.1c0.5,0.6,1.7,2.4,2.7,3.4c1.2,1.2,2.4,1.7,4.6,1.7c2.2,0,3.3-0.5,4.6-1.7c1-1,2.2-2.9,2.7-3.4
			C61.1,57.6,61,57.6,61,57.6z"/>
            <path style="fill:#ED625F;" d="M61.7,57.4c-1.4,0.1-5.4-0.4-7.5,0c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.3,0-0.3-0.1c-2.1-0.4-6.2,0.1-7.5,0
			c-0.2,0-0.5-0.1-1.1-0.2c0.1,0.1,0.4,0.2,0.7,0.2c2.5,0.6,5.6,0.6,8.3,0.6h0c2.7,0,5.7,0.1,8.3-0.6c0.2-0.1,0.5-0.1,0.7-0.2
			C62.2,57.3,61.8,57.3,61.7,57.4z"/>
        </g>
        <g>
            <path style="fill:#ED8173;" d="M45.4,56.9c0.1-0.2,0.5-0.4,0.7-0.5c0.1-0.1-1,0.1-1.2,0.6c-0.2,0.5,0.2,0.9,0.4,1.5
			c-0.1-0.7-0.1-0.9-0.1-1.2C45.2,57.1,45.3,57,45.4,56.9z"/>
            <path style="fill:#ED8173;" d="M62.3,56.9c-0.1-0.2-0.5-0.4-0.7-0.5c-0.1-0.1,1,0.1,1.2,0.6c0.2,0.5-0.2,0.9-0.4,1.5
			c0.1-0.7,0.1-0.9,0.1-1.2C62.5,57.1,62.4,57,62.3,56.9z"/>
        </g>
    </g>
</template>

<script>
    import Mouth from './Mouth';

    export default {
        name: 'Mouth14',
        mixins: [Mouth],
    }
</script>
